var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 19C38.5 29.2051 30.0057 37.5 19.5 37.5C8.99427 37.5 0.5 29.2051 0.5 19C0.5 8.7949 8.99427 0.5 19.5 0.5C30.0057 0.5 38.5 8.7949 38.5 19Z",
    stroke: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankCircle);
export default __webpack_public_path__ + "static/media/blank-circle.db3887337dc3fe22511b6b5fa47d24f0.svg";
export { ForwardRef as ReactComponent };